import type React from "react";

export function handleListNavigation({
    event,
    count,
    activeIndex,
    setActiveIndex,
    onSelect,
    onClose,
}: {
    event: Pick<React.KeyboardEvent, "key" | "preventDefault">;
    count: number;
    activeIndex: number;
    setActiveIndex: React.Dispatch<React.SetStateAction<number>>;
    onSelect: (index: number) => void;
    onClose: () => void;
}): boolean {
    if (event.key === "Escape") {
        event.preventDefault();
        onClose();
        return true;
    }
    if (count === 0) {
        return false;
    }
    switch (event.key) {
        case "ArrowDown":
            event.preventDefault();
            setActiveIndex((prev) => (prev >= count - 1 ? 0 : prev + 1));
            return true;
        case "ArrowUp":
            event.preventDefault();
            setActiveIndex((prev) => (prev <= 0 ? count - 1 : prev - 1));
            return true;
        case "Tab":
        case "Enter":
            event.preventDefault();
            onSelect(Math.min(activeIndex, count - 1));
            return true;
        default:
            return false;
    }
}
